import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderLifeCycleEventImplEncoder } from "../../encoder/OrderLifeCycleEventImplEncoder";

import * as CubiqTS from "../../index";
import { OrderLifeCycleEvent } from "../OrderLifeCycleEvent";

export class OrderLifeCycleEventImpl extends ConcreteEncodable implements OrderLifeCycleEvent {
  public static enType: string = "com.bcdfx.model.event.lifecycle.OrderLifeCycleEventImpl";

  /*FID=1*/
  public targetUserCode: string;
  /*FID=3*/
  public externalClientReference: string;
  /*FID=4*/
  public orderId: string;
  /*FID=5*/
  public strategyId: string;
  /*FID=6*/
  public eventTypeId: CubiqTS.FxLifeCycleEventType;
  /*FID=7*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=8*/
  public strategyComponentState: Array<CubiqTS.StrategyComponentState> | null = null;
  /*FID=9*/
  public fxOrderLifeCycleEvent: CubiqTS.FxLifeCycleEventType;
  /*FID=10*/
  public id: string;
  /*FID=11*/
  public strategyOrderState: Array<CubiqTS.StrategyComponentState> | null = null;
  /*FID=12*/
  public orderData: CubiqTS.OrderData | null = null;
  /*FID=13*/
  public linkReference: string;
  /*FID=14*/
  public rollbackEventFg: boolean;
  /*FID=15*/
  public rejectType: CubiqTS.RejectSubType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderLifeCycleEventImplEncoder.Instance;
    this.setEncodableType(OrderLifeCycleEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderLifeCycleEventImpl[" +
      "targetUserCode=" +
      this.targetUserCode +
      "externalClientReference=" +
      this.externalClientReference +
      "orderId=" +
      this.orderId +
      "strategyId=" +
      this.strategyId +
      "eventTypeId=" +
      this.eventTypeId +
      "errors=" +
      this.errors +
      "strategyComponentState=" +
      this.strategyComponentState +
      "fxOrderLifeCycleEvent=" +
      this.fxOrderLifeCycleEvent +
      "id=" +
      this.id +
      "strategyOrderState=" +
      this.strategyOrderState +
      "orderData=" +
      this.orderData +
      "linkReference=" +
      this.linkReference +
      "rollbackEventFg=" +
      this.rollbackEventFg +
      "rejectType=" +
      this.rejectType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
